import script from "./layoutContents.vue?vue&type=script&setup=true&lang=js"
export * from "./layoutContents.vue?vue&type=script&setup=true&lang=js"

import "./layoutContents.vue?vue&type=style&index=0&id=c42df7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c42df7b6"]])

export default __exports__